// extracted by mini-css-extract-plugin
export default {"copyText":"CopyButton_copyText__O9+0K"};